import React, { useMemo } from "react"
import { CustomModal } from "./modal"
import TableContainer from "../components/TableContainer"
import moment from "moment";

function ViewLeaveHistoryModal({ isOpen, onClose, list }) {

  const columns = useMemo(() => [
    {
      accessor: 'expert_email',
      Header: 'Email',
    },
    {
      accessor: 'expert_name',
      Header: 'Name',
    },
    {
      accessor: 'source',
      Header: 'By',
    },
    {
      accessor: 'reason',
      Header: 'Reason',
    },
    {
      accessor: 'date',
      Header: 'Date',
      Cell: ({ row }) => {
        const { date } = row.original
        return moment(date).format('ll')
      }
    },
  ]);

  return (
    <CustomModal
      open={isOpen}
      onClose={onClose}
      className="commonCustomModal feedbackModal"
      body={
        <div>
          <TableContainer columns={columns} data={list || []} hiddenColumns={[]} />
        </div>
      }
    />
  );
}


export { ViewLeaveHistoryModal }